import React from "react";

import MainContentCard from "../../../Home/MainContentCard";
const TCInventoryStatus = () => {
  return <MainContentCard>TC Inventory</MainContentCard>;
};

export default TCInventoryStatus;
